import { ServerConfig } from "@/config/config";
import RawAxios from "axios";
import { Axios } from "@/utils/axios";
import { EventEmitter } from "@/utils/event-emitter";

const url = `${ServerConfig.auth}/motd`;

export interface Motd {
	id:number;
	translations:{[key:string]:string};
}

class MotdServiceClass extends EventEmitter {
	async getCurrentMotd():Promise<Motd | null>{
		let response = await RawAxios.get(url);
		if (!response.data) {
			return null;
		}
		return response.data;
	}

	async getLastSeenMotdId():Promise<number>{
		let response = await Axios.get(`${url}/last-seen`);
		return (response.data && response.data.lastSeenMotdId) || 0;
	}

	async markMotdSeen(id:number):Promise<void>{
		await Axios.post(`${url}/seen`, {id});
	}
}

export const MotdService = new MotdServiceClass();
